import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnToggleTooltipFormField } from './components/form-field/toggle-tooltip.form-field';

@NgModule({
  declarations: [SnToggleTooltipFormField],
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    // Material
    MatIconModule,
    MatSlideToggleModule,
    MatTooltipModule,
    // Formly
    FormlyModule.forChild({
      types: [
        {
          name: 'toggle-tooltip',
          component: SnToggleTooltipFormField,
        },
      ],
    }),
  ],
  exports: [MatSlideToggleModule],
})
export class SnFormToggleTooltipModule {}
